import { triggerCustomEvent } from "./EventTrigger";

export default class Expander
{
    protected root: HTMLElement;
    protected expandableBlock: HTMLElement;
    protected button: HTMLElement;
    protected expandable: boolean;
    protected label = {
        open: 'Показать все',
        close: 'Свернуть',
    };
    protected classes = {
        expandableBody: 'expander__body',
        opened: 'expander__body-opened',
    };

    public constructor(root: HTMLElement, labelOpen: string = '', labelClose: string = '')
    {
        this.root = root;
        if (labelOpen !== '') {
            this.label.open = labelOpen;
        }
        if (labelClose !== '') {
            this.label.close = labelClose;
        }
        this.expandableBlock = this.root.querySelector('.' + this.classes.expandableBody);
        this.expandable = this.isExpandable();
        this.init();
    }

    protected init()
    {
        if (this.expandable && !this.expandableBlock.classList.contains('expander__inited')) {
            this.renderSwitcher();
            this.appendEventListeners();
        }
    }

    protected getCloseLabel()
    {
        return this.label.close;
    }

    protected getOpenLabel()
    {
        return this.label.open;
    }

    protected isExpandable()
    {
        if (this.expandableBlock.scrollHeight > this.root.offsetHeight) {
            return true;
        }

        return false;
    }

    protected renderSwitcher()
    {
        let switcher = document.createElement('div');
        switcher.classList.add('expander');
        switcher.classList.add('expander__button');
        switcher.classList.add('expander__button_light-green-border');
        switcher.classList.add('display_none');
        switcher.classList.add('visible_xs');
        switcher.classList.add('js-expander-switcher');
        switcher.innerHTML = this.label.open;

        this.root.appendChild(switcher);
        this.expandableBlock.classList.add('expander__inited');
    }  

    protected switchSwitcherState(switcher: HTMLElement)
    {
        if (this.isFormExpanded()) {
            switcher.innerText = this.getCloseLabel();
        } else { 
            switcher.innerText = this.getOpenLabel();
            //this.scrollToTop();
        }

        switcher.classList.toggle('expander__button-opened');
    }    

    protected appendEventListeners()
    {
        let switcher = this.root.querySelector<HTMLElement>('.js-expander-switcher');
        this.switcherClickHandler(switcher);
    }

    protected switcherClickHandler(switcher: HTMLElement)
    {
        switcher.addEventListener('click', () => {
            this.expandableBlock.classList.toggle(this.classes.opened);
            this.expandableBlock.classList.add('expander__inited');
            this.switchSwitcherState(switcher);
        });
    }

    protected isFormExpanded(): boolean
    {
        return this.expandableBlock.classList.contains(this.classes.opened);
    }

    protected scrollToTop()
    {
        // console.log(this.root.scrollHeight);
        // window.scrollBy({
        //     top: -(this.root.scrollHeight), 
        //     left: 0, 
        //     behavior : "smooth"
        // });
    }
}
